export enum TipoAlertaEnum {

  DivergenciaMovimentacaoReceita = "Divergência entre Movimentação e Receita",
  QuedaArrecadacao = "Queda de arrecadação",
  MovimentacaoAtipica = "Movimentação atípica",
  TributacaoExcessivaFora = "Tributação excessiva fora do município",
  AliquotaSimplesIncorreta = "Alíquota Simples Incorreta",
  RegimeSimplesIncorreto = "Regime Configurado Incorretamente"
}
